import { render, staticRenderFns } from "./navManage.vue?vue&type=template&id=24d7e5bd&scoped=true&"
import script from "./navManage.vue?vue&type=script&lang=js&"
export * from "./navManage.vue?vue&type=script&lang=js&"
import style0 from "./navManage.vue?vue&type=style&index=0&id=24d7e5bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d7e5bd",
  null
  
)

export default component.exports